import { useState } from "react";
import { useAuth } from "../lib/auth";
import { LogIn, X, ShieldCheck } from "lucide-react";

/**
 * Soft-Wall: bouton qui déclenche une modal de connexion Google 1-clic
 * si l'utilisateur n'est pas connecté, sinon exécute onAction.
 * Usage: <AuthGate reason="sauvegarder dans le Coffre-Fort" onAction={handleUpload}>
 *          {(trigger) => <button onClick={trigger}>Déposer</button>}
 *        </AuthGate>
 */
export function AuthGate({ reason = "continuer", onAction, children }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  const trigger = () => {
    if (user) { onAction && onAction(); return; }
    setOpen(true);
  };

  const google = () => {
    const redirectUrl = window.location.href;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <>
      {children(trigger)}
      {open && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-testid="authgate-modal" onClick={() => setOpen(false)}>
          <div className="j-card max-w-sm w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-start justify-between mb-3">
              <div className="w-10 h-10 rounded-lg bg-[#10B981]/10 text-[#10B981] flex items-center justify-center"><ShieldCheck className="w-5 h-5" /></div>
              <button onClick={() => setOpen(false)} className="text-slate-400 hover:text-slate-700" data-testid="authgate-close"><X className="w-4 h-4" /></button>
            </div>
            <h3 className="font-heading font-black text-lg">Connexion requise</h3>
            <p className="text-sm text-slate-600 mt-1">Connectez-vous en 1 clic avec Google pour <b>{reason}</b>. Aucune donnée n'est stockée sans votre accord.</p>
            <button onClick={google} className="w-full mt-5 border border-slate-300 rounded-full h-11 flex items-center justify-center gap-2 bg-white hover:bg-slate-50 font-semibold text-slate-700" data-testid="authgate-google">
              <svg viewBox="0 0 24 24" className="w-5 h-5"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
              Continuer avec Google
            </button>
            <div className="text-center text-xs text-slate-500 mt-3">
              ou <a href="/login" className="text-[#10B981] font-semibold">créer un compte email</a>
            </div>
            <div className="text-[0.65rem] text-slate-400 mt-3 text-center leading-relaxed">
              🛡️ Politique Zero-Data Retention · Vos données sont anonymisées avant tout traitement.
            </div>
          </div>
        </div>
      )}
    </>
  );
}
